export default "__VITE_ASSET__D$vJcpKv__"